import { useMutation } from 'react-query';

import { useCompany } from 'modules/app/hooks/useCompany';
import { postV2ApiCompanyIdRequestsDenials } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdRequestsDenialsResponseOK } from 'src/client/spendesk-api-types';

export type RequestsDenials =
  PostV2ApiCompanyIdRequestsDenialsResponseOK['data'];

export const useRequestsDenialsMutation = () => {
  const company = useCompany();
  return useMutation(
    ['v2', 'requests', 'denials'],
    async ({
      requestIds,
      denialReason,
    }: {
      requestIds: string[];
      denialReason: string;
    }): Promise<{ data: RequestsDenials }> => {
      const response = await postV2ApiCompanyIdRequestsDenials({
        path: {
          companyId: company.id,
        },
        body: {
          requestIds,
          denialReason,
        },
      });
      if (response.statusCode !== 200) {
        throw new Error('Failed to deny requests');
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
